import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoles, homePathForRole } from './appRoles';

/** Paths vendors may access (customer marketplace is blocked). */
export const VENDOR_ALLOWED_PREFIXES = [
  '/vendor',
  '/story-studio',
  '/login',
  '/language',
  '/help-support',
  '/terms',
  '/privacy',
  '/security',
] as const;

export function isVendorUser(role?: string | null) {
  return String(role || '').toLowerCase() === AppRoles.Vendor;
}

export function isVendorAllowedPath(pathname: string) {
  return VENDOR_ALLOWED_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

/** Redirect vendors away from customer marketplace routes. */
export function VendorRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const role = localStorage.getItem('userType');
    if (!isVendorUser(role)) return;
    if (isVendorAllowedPath(location.pathname)) return;
    navigate(homePathForRole(AppRoles.Vendor), { replace: true });
  }, [location.pathname, navigate]);

  return null;
}
